import React, { useEffect, useState } from "react";
import TextField from "../../../common/TextField";
import { Grid, IconButton, Box } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import Button from "../../../../Components/common/Button";
import { updateAccount } from "../../../../Actions/Accounts";
import { updateUser } from "../../../../Actions/Users";
import { toast } from "react-toastify";
import { ServerInfo } from "../../../../Actions/serverSetting";
import { checkPrivileges } from "../../../../Helpers";
import Checkbox from "../../../common/Checkbox";

const AdditionalEmails = (props) => {
  const [accountEmails, setAccountEmails] = useState([]);
  const [userEmails, setUserEmails] = useState([]);

  const [isCheckedEstimate, setIsCheckedEstimate] = useState(
    props.selectedUser?.sendNotification?.estimate || false,
  );
  const [isCheckedOutstanding, setIsCheckedOutstanding] = useState(
    props.selectedUser?.sendNotification?.outstanding || false,
  );
  const [isCheckedAipms, setIsCheckedAipms] = useState(
    props.selectedUser?.sendNotification?.aipms || false,
  );
  const [isCheckedPushNotification, setIsCheckedPushNotification] = useState(
    props.selectedUser?.sendNotification?.pushNotification || false,
  );
  const [isCheckedLicense, setIsCheckedLicense] = useState(
    props.selectedUser?.sendNotification?.license || false,
  );
  const [isCheckedInsurance, setIsCheckedInsurance] = useState(
    props.selectedUser?.sendNotification?.insurance || false,
  );
  const [isCheckedCompliance, setIsCheckedCompliance] = useState(
    props.selectedUser?.sendNotification?.compliance || false,
  );
  useEffect(() => {
    if (props.isUser && props.selectedUser) {
      const updatedUserEmails = props.selectedUser?.additionalEmail
        ? props.selectedUser.additionalEmail.split(",")
        : [];
      setUserEmails(updatedUserEmails);
      setIsCheckedEstimate(
        props.selectedUser?.sendNotification?.estimate || false,
      );
      setIsCheckedOutstanding(
        props.selectedUser?.sendNotification?.outstanding || false,
      );
      setIsCheckedAipms(props.selectedUser?.sendNotification?.aipms || false);
      setIsCheckedPushNotification(
        props.selectedUser?.sendNotification?.pushNotification || false,
      );
      setIsCheckedLicense(
        props.selectedUser?.sendNotification?.license || false,
      );
      setIsCheckedInsurance(
        props.selectedUser?.sendNotification?.insurance || false,
      );
      setIsCheckedCompliance(
        props.selectedUser?.sendNotification?.compliance || false,
      );
    }

    if (props.selectedAccount) {
      const updatedAccountEmails = props.selectedAccount?.additionalEmail
        ? props.selectedAccount.additionalEmail.split(",")
        : [];
      setAccountEmails(updatedAccountEmails);
    }
  }, [props.isUser, props.selectedUser, props.selectedAccount]);

  const handleSubmitForm = async () => {
    const { createdOriginal, ...userRest } = props.selectedUser || {};
    const userPayload = props.isUser
      ? {
          ...userRest,
          additionalEmail: userEmails.join(","),
          created: createdOriginal || userRest.created,
        }
      : null;

    const accountPayload = {
      ...props.selectedAccount,
      additionalEmail: accountEmails.join(","),
    };

    const userApiUrl = `api/users/${props.selectedUser?.id}`;
    const accountApiUrl = `api/accounts/${props.selectedAccount?.id}`;

    try {
      if (props.isUser && userPayload) {
        const userResponse = await fetch(userApiUrl, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userPayload),
        });

        if (!userResponse.ok) throw new Error("User API call failed");

        const userResult = await userResponse.json();
        if (userResult.status === "success") {
          toast.success(props.translate("User email successfully updated"));
          props.UpdateSelectedItem(userResult.data);
          props.dispatch(updateUser(userResult.data));
        }
      }

      // Make the account API call
      const accountResponse = await fetch(accountApiUrl, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(accountPayload),
      });

      if (!accountResponse.ok) throw new Error("Account API call failed");

      const accountResult = await accountResponse.json();
      if (accountResult.status === "success") {
        toast.success(props.translate("Account email successfully updated"));
        props.updateSelectedAccount(accountResult.data);
        props.dispatch(updateAccount(accountResult.data));

        if (props.selectedAccount.id === 1) {
          props.dispatch(ServerInfo(accountResult.data));
        }
      }
    } catch (error) {
      toast.error(props.translate("somethingWentWrong"));
    }
  };

  const handleUserEmailChange = (index) => (event) => {
    const newEmails = [...userEmails];
    newEmails[index] = event.target.value;
    setUserEmails(newEmails);
  };

  const handleAccountEmailChange = (index) => (event) => {
    const newEmails = [...accountEmails];
    newEmails[index] = event.target.value;
    setAccountEmails(newEmails);
  };

  const addUserEmailField = () => {
    setUserEmails([...userEmails, ""]);
  };

  const addAccountEmailField = () => {
    setAccountEmails([...accountEmails, ""]);
  };

  const removeUserEmailField = (index) => () => {
    const newEmails = userEmails.filter((_, i) => i !== index);
    setUserEmails(newEmails);
  };

  const removeAccountEmailField = (index) => () => {
    const newEmails = accountEmails.filter((_, i) => i !== index);
    setAccountEmails(newEmails);
  };

  const handleNotificationChange = (type) => (e) => {
    const checked = e.target.checked;
    if (type === "estimate") setIsCheckedEstimate(checked);
    if (type === "outstanding") setIsCheckedOutstanding(checked);
    if (type === "aipms") setIsCheckedAipms(checked);
    if (type === "pushNotification") setIsCheckedPushNotification(checked);
    if (type === "license") setIsCheckedLicense(checked);
    if (type === "insurance") setIsCheckedInsurance(checked);
    if (type === "compliance") setIsCheckedCompliance(checked);
  };

  const handleSubmitFormEstimate = async () => {
    const { createdOriginal, ...userRest } = props.selectedUser || {};
    const userPayload = {
      ...userRest,
      created: createdOriginal || userRest.created,
      sendNotification: {
        ...(props.selectedUser?.sendNotification || {}),
        estimate: isCheckedEstimate,
        outstanding: isCheckedOutstanding,
        aipms: isCheckedAipms,
        pushNotification: isCheckedPushNotification,
        license: isCheckedLicense,
        compliance: isCheckedCompliance,
        insurance: isCheckedInsurance,
      },
    };

    const userApiUrl = `api/users/${props.selectedUser?.id}`;

    try {
      const userResponse = await fetch(userApiUrl, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userPayload),
      });

      if (!userResponse.ok) throw new Error("User API call failed");

      const userResult = await userResponse.json();
      if (userResult.status === "success") {
        toast.success(props.translate("User successfully updated"));
        props.UpdateSelectedItem(userResult.data);
        props.dispatch(updateUser(userResult.data));
      }
    } catch (error) {
      toast.error(props.translate("somethingWentWrong"));
    }
  };

  return (
    <div>
      <h4>
        {props.translate(
          `${props.isUser ? "Manage User and Account Additional Emails" : "Manage Account Additional Emails"}`,
        )}
      </h4>
      <h5 style={{ margin: "1rem 0rem" }}>
        {props.translate("Account Additional Emails")}
      </h5>

      <Grid container spacing={2}>
        {accountEmails?.map((email, index) => (
          <Grid item xs={12} sm={6} md={4} key={`account-${index}`}>
            <Box display="flex" alignItems="center">
              <TextField
                id={`account-emails-${index}`}
                label={`${props.translate("Enter Account Email")} #${index + 1}`}
                type="text"
                value={email || ""}
                onChange={handleAccountEmailChange(index)}
                variant="outlined"
                margin="dense"
                fullWidth
              />
              <IconButton
                aria-label="delete"
                onClick={removeAccountEmailField(index)}
                size="small"
                color="error"
                sx={{ ml: 1 }}
              >
                <Delete />
              </IconButton>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={addAccountEmailField}
            color="primary"
          >
            {props.translate("Add Account Email")}
          </Button>
        </Grid>
      </Grid>

      {props.isUser && (
        <>
          <h5 style={{ margin: "1rem 0rem" }}>
            {props.translate("User Additional Emails")}
          </h5>
          <Grid container spacing={2}>
            {userEmails.map((email, index) => (
              <Grid item md={4} sm={6} xs={12} key={`user-${index}`}>
                <Box display="flex" alignItems="center">
                  <TextField
                    id={`user-emails-${index}`}
                    label={`${props.translate("Enter User Email")} #${index + 1}`}
                    type="text"
                    value={email || ""}
                    onChange={handleUserEmailChange(index)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                  <IconButton
                    aria-label="delete"
                    onClick={removeUserEmailField(index)}
                    size="small"
                    color="error"
                    sx={{ ml: 1 }}
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={addUserEmailField}
                color="primary"
              >
                {props.translate("Add User Email")}
              </Button>
            </Grid>
          </Grid>
        </>
      )}

      {checkPrivileges("userUpdate") && (
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitForm}
          >
            {props.translate("Submit")}
          </Button>
        </Box>
      )}
      {props.isUser && (
        <>
          <hr style={{ margin: "1rem 0rem" }} />

          <h4>{props.translate("Manage Notifications")}</h4>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedEstimate}
                onChange={handleNotificationChange("estimate")}
                canAssign
                canRemove
                label={props.translate("Service Estimate Email")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedOutstanding}
                onChange={handleNotificationChange("outstanding")}
                canAssign
                canRemove
                label={props.translate("Outstanding Balance Email")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedAipms}
                onChange={handleNotificationChange("aipms")}
                canAssign
                canRemove
                label={props.translate("AI-PMS Email")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedPushNotification}
                onChange={handleNotificationChange("pushNotification")}
                canAssign
                canRemove
                label={props.translate("Push Notification")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedLicense}
                onChange={handleNotificationChange("license")}
                canAssign
                canRemove
                label={props.translate("Lisence Expiry")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedInsurance}
                onChange={handleNotificationChange("insurance")}
                canAssign
                canRemove
                label={props.translate("Fleet Expiry")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Checkbox
                checked={isCheckedCompliance}
                onChange={handleNotificationChange("compliance")}
                canAssign
                canRemove
                label={props.translate("Compliance Expiry")}
              />
            </Grid>
          </Grid>
          {checkPrivileges("userUpdate") && (
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitFormEstimate}
              >
                {props.translate("Submit")}
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default AdditionalEmails;
